import { Check } from "lucide-react";
import { useEffect, useRef } from "react";
import { fr } from "@/i18n/fr";
import { selectStepCount, useViewerStore } from "@/state/store";

export function StepList() {
	const data = useViewerStore((s) => s.data);
	const stepIndex = useViewerStore((s) => s.stepIndex);
	const seen = useViewerStore((s) => s.seen);
	const total = useViewerStore(selectStepCount);
	const goStep = useViewerStore((s) => s.goStep);
	const listRef = useRef<HTMLUListElement>(null);
	useEffect(() => {
		listRef.current?.children[stepIndex]
			?.querySelector("button")
			?.scrollIntoView({ block: "nearest", inline: "center" });
	}, [stepIndex]);
	if (!data) return null;
	return (
		<ul className="steps" ref={listRef}>
			{data.steps.map((s, i) => {
				const n =
					s.num === 0
						? fr.stepLabel.intro
						: s.num > total
							? fr.stepLabel.end
							: String(s.num).padStart(2, "0");
				return (
					<li key={s.code}>
						<button
							type="button"
							className={`step ${seen.has(s.code) ? "seen" : ""}`}
							aria-current={i === stepIndex ? "step" : undefined}
							onClick={() => goStep(i)}
						>
							<span className="n">
								{seen.has(s.code) && i !== stepIndex && (
									<Check aria-hidden="true" strokeWidth={2.5} />
								)}
								{n}
							</span>
							<span className="t">{s.title.replace(/^Étape \d+ · /, "")}</span>
						</button>
					</li>
				);
			})}
		</ul>
	);
}
